<template>
  <Wrapper>
    <Topo logado />
    <MenuLateral />
    <InternaMain
      :class="{ paddingBottom: footer }"
      maxwidth-container="820px"
    >
      <TituloPagina :titulo="tituloPagina" class="mt-7" />

      <ListaAindaPrecisoDeAjuda class="pb-md-10" />

      <BtnVoltar
        v-if="$vuetify.breakpoint.smAndDown"
        max-width="800px"
      />
      <v-btn
        v-else
        class="mt-10"
        color="primary"
        data-cy="btn_voltar"
        outlined
        width="278"
        @click="$router.go(-1)"
      >
        Voltar
      </v-btn>
    </InternaMain>
  </Wrapper>
</template>

<script>

import Wrapper from '@/components/Wrapper.vue';
import Topo from '@/components/Topo.vue';
import MenuLateral from '@/components/MenuLateral.vue';
import InternaMain from '@/components/InternaMain.vue';
import BtnVoltar from '@/components/BtnVoltar.vue';
import TituloPagina from '@/components/TituloPagina.vue';
import ListaAindaPrecisoDeAjuda from '@/components/NaoEncontrei/ListaAindaPrecisoDeAjuda.vue';

export default {
  name: 'NaoEncontrei',

  components: {
    Wrapper,
    Topo,
    MenuLateral,
    InternaMain,
    BtnVoltar,
    TituloPagina,
    ListaAindaPrecisoDeAjuda,
  },

  data() {
    return {
      tituloPagina: 'Preciso de ajuda com a minha compra',
      footer: true,
    };
  },

};
</script>

<style lang="scss">
  .paddingBottom{
    padding-bottom: 0!important
  }
</style>
